<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      
    }
  },
  methods:{
  
  }
}
</script>
<style>
html,body,#app{
  width:100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #fff;
}
body{
  min-width: 1300px;
}

</style>
